<div class="layout-wrapper" [class.sidebar-collapsed]="sidebarService.isCollapsed()">
  <!-- Sidebar -->
  <app-sidebar class="sidebar"></app-sidebar>

  <!-- Right side -->
  <div class="layout-main-container">
    <div class="layout-main relative">
      <app-loader></app-loader>
      <header class="header-container">
        <img
          src="assets/images/icons/panel-right-open.svg"
          alt="Toggle sidebar icon"
          (click)="toggleSidebar()"
          class="menu-btn hover:!bg-gray-200"
        />
      </header>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
